import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";
import { setLoader } from "./WorkFlowRedux";
import { toast } from "react-toastify";

export const SubscriptionGetList = createAsyncThunk(
    "SubscriptionGetList",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.SUBSCRIPTIONS.GET_LIST,
                    body: {},
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const GetCurrentSubscription = createAsyncThunk(
    "GetCurrentSubscription",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.SUBSCRIPTIONS.GET_MY_SUBSCRIPTION,
                    body: {},
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const UpdatePlan = createAsyncThunk(
    "UpdatePlan",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL?.SUBSCRIPTIONS?.UPDATEPLAN,
                    body: data,
                },
                false
            );
            let response = apiResponse(false, resData);
            if (resData.status_code === 0) {
                toast.error(resData?.message);
            }
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const CalculateSubscriptionPrice = createAsyncThunk(
    "CalculateSubscriptionPrice",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL?.SUBSCRIPTIONS?.CALCULATE_PRICE,
                    body: data,
                },
                false
            );
            let response = apiResponse(false, resData);
            if (resData?.status_code === 0) {
                toast.error(resData?.message);
            }
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

const initialState = {
    SubscriptionGetListData: {
        data: null,
        error: null,
    },
    GetCurrentSubscriptionData: {
        data: null,
        error: null,
    },
    UpdatePlanData: {
        data: null,
        error: null,
    },
    CalculateSubscriptionPriceData: {
        data: null,
        error: null,
    },
};

const SubscriptionSlice = createSlice({
    name: "SubscriptionSlice",
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(SubscriptionGetList.fulfilled, (state, action) => {
                state.SubscriptionGetListData.data = action.payload;
            })
            .addCase(SubscriptionGetList.rejected, (state, action) => {
                state.SubscriptionGetListData.error = action.error.message;
            })
            .addCase(GetCurrentSubscription.fulfilled, (state, action) => {
                state.GetCurrentSubscriptionData.data = action.payload;
            })
            .addCase(GetCurrentSubscription.rejected, (state, action) => {
                state.GetCurrentSubscriptionData.error = action.error.message;
            })
            .addCase(UpdatePlan.fulfilled, (state, action) => {
                state.UpdatePlanData.data = action.payload;
            })
            .addCase(UpdatePlan.rejected, (state, action) => {
                state.UpdatePlanData.error = action.error.message;
            });
    },
});

// export const { setSubscriberIdData } = SubscriptionSlice.actions;
export default SubscriptionSlice.reducer;
